// extracted by mini-css-extract-plugin
export default {"campaignsList":"PromotionDetailsWarnModal__campaignsList-pmN4V"};